import { FilterObjectWrapper } from './filter.object.wrapper';
import { FilterSearchObject } from '../models/filter/filter.search.object';
import { FilterObject } from '../models/filter/filter.object';

export class FilterSequenceWrapper extends FilterObjectWrapper {
    dbTyp_NmFilterSearchObject: FilterSearchObject;
    aliasNmFilterSearchObject: FilterSearchObject;
    updateByFilterSearchObject: FilterSearchObject;

    constructor() {
        super();
        
        this.filterObject = new FilterObject();
        this.dbTyp_NmFilterSearchObject = new FilterSearchObject();
        this.aliasNmFilterSearchObject = new FilterSearchObject();
        this.updateByFilterSearchObject = new FilterSearchObject();
    }

    setFilterObject( filterObject: FilterObject ): void {
        this.filterObject.copyFrom( filterObject );

        for( let i: number = 0; i < this.filterObject.filterSearchObjects.length; i++ ) {
            let filterSearchObject: FilterSearchObject = this.filterObject.filterSearchObjects[i];

            if( filterSearchObject.obj_Cd == 'dbTyp_Nm' ) {
                this.dbTyp_NmFilterSearchObject = filterSearchObject;
                this.dbTyp_NmFilterSearchObject.searchItems.sort((a:any, b:any) => a.objNm.localeCompare(b.objNm));
                this.dbTyp_NmFilterSearchObject.searchItems =  this.dbTyp_NmFilterSearchObject.searchItems.filter(function(x){
                    x.objNm = x.objNm.length == 0 ? 'Un Assigned' : x.objNm;
                    return x;
                });
                continue;
            }

            if( filterSearchObject.obj_Cd == 'aliasNm' ) {
                this.aliasNmFilterSearchObject = filterSearchObject;
                this.aliasNmFilterSearchObject.searchItems.sort((a:any, b:any) => a.objNm.localeCompare(b.objNm));
                this.aliasNmFilterSearchObject.searchItems =  this.aliasNmFilterSearchObject.searchItems.filter(function(x){
                    x.objNm = x.objNm.length == 0 ? 'Un Assigned' : x.objNm;
                    return x;
                });
                continue;
            }

            if( filterSearchObject.obj_Cd == 'updateBy' ) {
                this.updateByFilterSearchObject = filterSearchObject;
                this.updateByFilterSearchObject.searchItems.sort((a:any, b:any) => a.objNm.localeCompare(b.objNm));
                this.updateByFilterSearchObject.searchItems =  this.updateByFilterSearchObject.searchItems.filter(function(x){
                    x.objNm = x.objNm.length == 0 ? 'Un Assigned' : x.objNm;
                    return x;
                });
                continue;
            }
        }
    }

    public get obj_Cd(): string {
        return this.filterObject.obj_Cd;
    }
}